module.exports = __webpack_public_path__ + "img/1747038622_4Mqy.069fff00.jpg";